class Accordion {
    constructor(element) {
        this.accordion = element;
        this.triggers = this.accordion.querySelectorAll('[data-accordion-trigger]');
        this.contents = this.accordion.querySelectorAll('[data-accordion-content]');
        
        this.init();
    }
    
    init() {
        this.triggers.forEach((trigger, index) => {
            trigger.addEventListener('click', () => {
                this.toggle(index);
            });
            
            // Keyboard navigation
            trigger.addEventListener('keydown', (e) => {
                this.handleKeydown(e, index);
            });
        });
    }
    
    toggle(index) {
        const trigger = this.triggers[index];
        const content = this.contents[index];
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
            // Close the current item
            this.close(index);
        } else {
            // Close all other items first
            this.closeAll();
            // Then open the clicked item
            this.open(index);
        }
    }
    
    open(index) {
        const trigger = this.triggers[index];
        const content = this.contents[index];
        
        // Dynamische Höhe berechnen
        const body = content.querySelector('.accordion-body');
        const height = body.scrollHeight;
        content.style.setProperty('--content-height', `${height}px`);
        
        trigger.setAttribute('aria-expanded', 'true');
        content.setAttribute('aria-hidden', 'false');
    }
    
    close(index) {
        const trigger = this.triggers[index];
        const content = this.contents[index];
        
        trigger.setAttribute('aria-expanded', 'false');
        content.setAttribute('aria-hidden', 'true');
        content.style.setProperty('--content-height', '0px');
    }
    
    closeAll() {
        this.triggers.forEach((trigger, index) => {
            if (trigger.getAttribute('aria-expanded') === 'true') {
                this.close(index);
            }
        });
    }
    
    handleKeydown(e, index) {
        const key = e.key;
        
        switch (key) {
            case 'ArrowDown':
                e.preventDefault();
                this.focusNext(index);
                break;
            case 'ArrowUp':
                e.preventDefault();
                this.focusPrevious(index);
                break;
            case 'Home':
                e.preventDefault();
                this.triggers[0].focus();
                break;
            case 'End':
                e.preventDefault();
                this.triggers[this.triggers.length - 1].focus();
                break;
        }
    }
    
    focusNext(currentIndex) {
        const nextIndex = currentIndex < this.triggers.length - 1 ? currentIndex + 1 : 0;
        this.triggers[nextIndex].focus();
    }
    
    focusPrevious(currentIndex) {
        const previousIndex = currentIndex > 0 ? currentIndex - 1 : this.triggers.length - 1;
        this.triggers[previousIndex].focus();
    }

    destroy() {
        // Cleanup method
        this.triggers.forEach((trigger, index) => {
            trigger.removeEventListener('click', () => this.toggle(index));
            trigger.removeEventListener('keydown', (e) => this.handleKeydown(e, index));
        });
    }
}

export function initAccordions() {
    const accordions = document.querySelectorAll('[data-accordion]');
    if (accordions.length === 0) {
        return [];
    }

    const instances = [];
    accordions.forEach(accordion => {
        const instance = new Accordion(accordion);
        instances.push(instance);
    });
    
    // Return cleanup function
    return () => {
        instances.forEach(instance => {
            instance.destroy();
        });

        instances.length = 0;
    };
}
